import {
  APIWorkspaceAttributes,
  APIWorkspaceOverview,
  ResourceType,
} from '@ardoq/api-types';
import {
  reducedStream,
  reducer,
  streamReducer,
  toPersistentStream,
} from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { fetchAllReducer, websocketReducer } from 'streams/crud/reducers';
import { filterResourceType, websocket$ } from 'sync/websocket$';
import {
  getStreamCollectionInitialState,
  StreamCollection,
  toStreamCollection,
} from 'streams/utils/streamUtils';
import * as workspaceActions from './actions';
import {
  removeMany,
  replaceFromWorkspaces,
  upsertMany,
  upsertOne,
} from './workspaceOverviewsOperations';

export const workspaceOverviewNamespace = 'workspaceOverview';

export type WorkspaceOverviewsState = StreamCollection<APIWorkspaceOverview>;

const resetFromOverview = (
  _: APIWorkspaceOverview[],
  overviews: APIWorkspaceOverview[]
): APIWorkspaceOverview[] => overviews;

const clearAll = (): APIWorkspaceOverview[] => [];

const handleResetWorkspacesWithData = (
  state: APIWorkspaceOverview[],
  { workspaces }: workspaceActions.AddWorkspacesPayload
): APIWorkspaceOverview[] => replaceFromWorkspaces(state, workspaces);

const handleAddWorkspaces = (
  state: APIWorkspaceOverview[],
  { workspaces }: workspaceActions.AddWorkspacesPayload
): APIWorkspaceOverview[] => upsertMany(state, workspaces);

const workspaceOverviews$ = reducedStream<APIWorkspaceOverview[]>(
  'workspaceOverviewsOnly$',
  [],
  [
    fetchAllReducer(resetFromOverview),
    reducer(workspaceActions.resetWorkspaces, clearAll),
    reducer(
      workspaceActions.resetWorkspacesWithData,
      handleResetWorkspacesWithData
    ),
    reducer(workspaceActions.addWorkspaces, handleAddWorkspaces),
    reducer(workspaceActions.removeWorkspaces, removeMany),
    streamReducer(
      websocket$.pipe(
        filterResourceType<APIWorkspaceAttributes>(ResourceType.WORKSPACE)
      ),
      websocketReducer<APIWorkspaceOverview[], APIWorkspaceAttributes>({
        update: upsertOne,
      })
    ),
  ],
  { namespace: workspaceOverviewNamespace }
);

export const persistentWorkspaceOverviews$ = toPersistentStream(
  'workspaceOverviews$',
  workspaceOverviews$.pipe(map(toStreamCollection)),
  getStreamCollectionInitialState()
);
